import React from 'react';

import { ReactComponent as CopyLinkIcon } from '../../../assets/images/iconCopyLink.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/images/iconFacebook.svg';
import { ReactComponent as LinkedInIcon } from '../../../assets/images/iconLinkedin.svg';
import { ReactComponent as WhatsAppIcon } from '../../../assets/images/iconWhatsapp.svg';
import { ReactComponent as XIcon } from '../../../assets/images/iconX.svg';
import ShareButton from '../../Company/ShareModal/ShareButton/ShareButton';

import styles from './SocialShareButton.module.scss';

const SocialShareButton = ({ handleSocialShare, onCopyLink }) => (
  <div className={styles.shareButtons}>
    <ShareButton
      icon={<LinkedInIcon />}
      linkButtons={styles.linkButtons}
      onClick={() => handleSocialShare('LinkedIn')}
    />
    <ShareButton
      icon={<WhatsAppIcon />}
      linkButtons={styles.linkButtons}
      onClick={() => handleSocialShare('WhatsApp')}
    />
    <ShareButton icon={<XIcon />} linkButtons={styles.buttonPadding} onClick={() => handleSocialShare('Twitter')} />
    <ShareButton
      icon={<FacebookIcon />}
      linkButtons={styles.buttonPadding}
      onClick={() => handleSocialShare('Facebook')}
    />
    <ShareButton icon={<CopyLinkIcon />} linkButtons={styles.buttonPadding} onClick={onCopyLink} />
  </div>
);

export default SocialShareButton;
